import { DVCVariable, DVCVariableValue } from '@devcycle/js-client-sdk';
import { useVariable as originalUseVariable, useVariableValue as originalUseVariableValue } from '@devcycle/react-client-sdk';

type DVCJSON = { [key: string]: string | boolean | number };

export type DVCVariableTypes = {
    /*
    description: Path to a site's Create project settings
    created by: Christian Parsons
    created on: 2024-02-05
    */
    project_typhlosion_ui: string;
    /*
    description: Path to a site's Create project environment variables settings
    created by: Christian Parsons
    created on: 2024-02-05
    */
    project_typhlosion_ui2: string;
    /*
    description: Move Project Settings into Core
    created by: Christian Parsons
    created on: 2024-02-01
    */
    project_spheal_ui: boolean;
    /*
    description: Allow connecting to Contentstack with OAuth
    created by: alex baldwin
    created on: 2024-01-29
    */
    project_stakataka_ui: boolean;
    /*
    description: Transform existing analytic event names to use Netlify's Amplitude format
    created by: Christian Parsons
    created on: 2024-01-25
    */
    project_kyurem_ui: boolean;
    /*
    description: Platform Unification - show Team and Organization based navigation
    created by: Suzanne Aitchison
    created on: 2024-01-22
    */
    project_sealeo_ui: boolean;
    /*
    description: Display the Team Overview link on the dashboard to customers who can use app.netlify.com
    created by: Christian Parsons
    created on: 2024-01-04
    */
    project_whismur_ui: boolean;
    /*
    description: This is a description for this example feature.
    created by: Kaelig Deloumeau-Prigent
    created on: 2023-12-19
    */
    'example-feature': boolean;
};

export type UseVariableValue = <K extends string & keyof DVCVariableTypes, T extends DVCVariableValue & DVCVariableTypes[K]>(
    key: K,
    defaultValue: T
) => DVCVariable<T>['value'];

export const useVariableValue: UseVariableValue = originalUseVariableValue;

export type UseVariable = <K extends string & keyof DVCVariableTypes, T extends DVCVariableValue & DVCVariableTypes[K]>(
    key: K,
    defaultValue: T
) => DVCVariable<T>;

export const useVariable: UseVariable = originalUseVariable;
